import { render, staticRenderFns } from "./CommunityEdit.vue?vue&type=template&id=780d2636&scoped=true"
import script from "./CommunityEdit.vue?vue&type=script&lang=js"
export * from "./CommunityEdit.vue?vue&type=script&lang=js"
import style0 from "./CommunityEdit.vue?vue&type=style&index=0&id=780d2636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780d2636",
  null
  
)

export default component.exports